var CopySubscribe = function(gal){
	var _this = this,
		coverFrontTemplate = "",
		coverBackTemplate = "";

	function _init(){
		// _copyFrontCover();
		// _copyBackCover();

		// window.addEventListener('view.first.page.show', _copyFrontCover);
		window.addEventListener('view.last.page.show', _copyBackCover);
	}

	function _copyFrontCover(){
		//TODO only if it is cover page.
		// cl('_copyFrontCover');

		if(coverFrontTemplate === ""){
			coverFrontTemplate = $('#cover-front').html();
		}
		
		$('#front-cover').html(coverFrontTemplate);

		// $('#cover-front').remove();

		fireEvent(window, 'view.page.subscribe.copied');
	}
	
	function _copyBackCover(){
		// cl('_copyBackCover');

		if(coverBackTemplate === ""){
			coverBackTemplate = $('#cover-back').html();
		}
		
		$('#back-cover').html(coverBackTemplate);
		//$('#back-cover').closest('.page').height('100%');
		$('#back-cover').find('#brand-popup').remove();

		//do not remove cover after copy, because it is constantly being copied as html
		// $('#cover-back').remove();

		gal.generateRelatedForBackCover();
		setTimeout(function(){
			gal.generateRelatedForBackCoverSecond();
		}, 500);
		fireEvent(window, 'view.page.subscribe.copied');
	}

	_this.init = _init;
	_this.copyFrontCover = _copyFrontCover;
	_this.copyBackCover = _copyBackCover;
};